/**
 * Created by mac on 7/23/25
 */

const KingscupMerge2Adapter = {
    SubscribeToEvents: function () {
        const updateIcon = function () {
            const mission = cleverapps.missionManager.findByType(Mission.TYPE_KINGSCUP);
            const location = cleverapps.meta.getSelectedLocation();
            if (mission && mission.isRunning()) {
                mission.logic.setReady(location.stars.isEnoughStars());
                mission.logic.updateIcon();
            }
        };

        cleverapps.missionManager.on("add", (mission) => {
            if (!Merge2.current) {
                return;
            }
            if (mission.getType() === Mission.TYPE_KINGSCUP) {
                cleverapps.eventBus.trigger("updateExtraBar");
                updateIcon();
                cleverapps.eventBus.trigger("ordersDataSourceUpdateAll");
            }
        });

        cleverapps.missionManager.on("remove", (mission) => {
            if (!Merge2.current) {
                return;
            }
            if (mission.getType() === Mission.TYPE_KINGSCUP) {
                cleverapps.extraBar.removeIcon(KingsCupExtraBarIcon);
                cleverapps.eventBus.trigger("ordersDataSourceUpdateAll");
            }
        });

        const showStartHint = function () {
            const mission = cleverapps.missionManager.findByType(Mission.TYPE_KINGSCUP);

            let actions = [];

            if (mission.logic.ready) {
                actions = [
                    (f) => {
                        const repairView = cleverapps.Scenes.GetSceneComponent(Merge2SceneComponent).roomView.getRepairView();

                        if (repairView) {
                            FingerView.hintTap(repairView, {
                                runOnce: true,
                                callback: f
                            });
                            cleverapps.focusManager.setEventNodes([repairView]);
                        }
                    },
                    (f) => {
                        cleverapps.timeouts.setTimeout(f, 1000);
                    }
                ];
            } else {
                const customersList = Merge2.current.customers.listCustomersWithRecipe().filter((customer) => !customer.recipe.sideQuest);
                if (customersList.length) {
                    actions = [
                        (f) => {
                            const customerView = customersList[0].onGetView();
                            FingerView.hintTap(customerView, {
                                runOnce: true,
                                callback: f
                            });
                            cleverapps.focusManager.setEventNodes([customerView]);

                            cleverapps.Scenes.GetSceneComponent(Merge2SceneComponent).ordersTable.scrollToRow(customersList[0].recipe.index);
                        }
                    ];
                }
            }

            if (mission.logic.ready) {
                Merge2.current.changeMode(Merge2.MODE_META, () => {});
            } else {
                Merge2.current.changeMode(Merge2.MODE_GAME, () => {});
            }

            cleverapps.focusManager.whenFreeFocus(() => {
                cleverapps.focusManager.display({
                    focus: "KingsKupShowStartHint",
                    keepControls: true,
                    actions
                });
            });
        };

        const startCompetition = function () {
            const mission = cleverapps.missionManager.findByType(Mission.TYPE_KINGSCUP);
            if (mission && mission.isRunning()) {
                mission.logic.startCompetition();
            }
        };

        cleverapps.missionManager.on("kingsCupStart", (mission) => {
            if (mission.getType() === Mission.TYPE_KINGSCUP && mission.isRunning()) {
                const location = cleverapps.meta.getSelectedLocation();
                if (location.isLocationCompleted()) {
                    startCompetition();
                } else {
                    showStartHint();
                }
            }
        });

        cleverapps.eventBus.on("order_stars", (amount) => {
            const mission = cleverapps.missionManager.findByType(Mission.TYPE_KINGSCUP);
            if (mission && mission.isRunning()) {
                mission.logic.earnPoints(amount);
            }

            cleverapps.personalBest.addPoint("kingscup", amount);
        });

        cleverapps.eventBus.on("garden_fix", () => {
            const mission = cleverapps.missionManager.findByType(Mission.TYPE_KINGSCUP);
            if (mission && mission.isRunning() && !mission.logic.isUnlocked()) {
                mission.logic.readyToUnlock = true;
            }
        });

        cleverapps.eventBus.on("add_stars", () => {
            updateIcon();
        });

        cleverapps.eventBus.on("updateExtraBar", () => {
            const mission = cleverapps.missionManager.findByType(Mission.TYPE_KINGSCUP);
            if (!mission || !mission.isRunning()) {
                return;
            }

            if (cleverapps.resolution.isVertical()) {
                cleverapps.extraBar.removeIcon(KingsCupExtraBarIcon, true);
            } else {
                cleverapps.extraBar.addIcon(KingsCupExtraBarIcon);
            }
        });
    }
};

cleverapps.whenAllInitialized(() => KingscupMerge2Adapter.SubscribeToEvents());